/* ============================================================
   MESSLESS OS — theme behaviour
   Config is injected on window.MESSLESS by layout/theme.liquid.
   ============================================================ */
(function () {
  var CFG = window.MESSLESS || {};
  var root = document.documentElement;

  /* ---------- day / night ---------- */
  function applyTheme(night) {
    root.classList.toggle('night', night);
    document.querySelectorAll('[data-cta-day]').forEach(function (el) {
      el.textContent = night ? el.getAttribute('data-cta-night') : el.getAttribute('data-cta-day');
      var href = night ? el.getAttribute('data-href-night') : el.getAttribute('data-href-day');
      if (href) el.setAttribute('href', href);
    });
  }
  if (CFG.forceTheme === 'night') {
    applyTheme(true);
  } else if (CFG.forceTheme === 'day') {
    applyTheme(false);
  } else {
    var saved = null;
    try { saved = localStorage.getItem('ml-theme'); } catch (e) {}
    var mode = CFG.themeMode || 'auto';
    var night;
    if (saved) night = (saved === 'night');
    else if (mode === 'night') night = true;
    else if (mode === 'day') night = false;
    else { var h = new Date().getHours(); night = (h < 6 || h >= 18); }
    applyTheme(night);
    var toggle = document.getElementById('themeToggle');
    if (toggle) toggle.addEventListener('click', function () {
      var n = !root.classList.contains('night');
      applyTheme(n);
      try { localStorage.setItem('ml-theme', n ? 'night' : 'day'); } catch (e) {}
    });
  }

  /* ---------- boot (once per session, skip ad traffic) ---------- */
  var fromCampaign = /[?&](utm_|fbclid|ttclid|gclid)/i.test(location.search);
  var booted = false;
  try { booted = !!sessionStorage.getItem('ml-booted'); } catch (e) {}
  if (!CFG.showBoot || fromCampaign || booted) {
    root.classList.add('no-boot');
  } else {
    try { sessionStorage.setItem('ml-booted', '1'); } catch (e) {}
  }

  /* ---------- clock ---------- */
  function tick() {
    var d = new Date();
    var t = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    var c = document.getElementById('clock'); if (c) c.textContent = t;
    var s = document.getElementById('statusLine'); if (s) s.textContent = 'Connected · ' + t;
  }
  tick(); setInterval(tick, 15000);

  /* ---------- money ---------- */
  var CUR = CFG.currency || 'USD';
  var NAME_MAP = { 'flow': 'Flow', 'restore': 'Restore', 'flow-restore': 'The System' };
  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('cartDrawer');
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    CUR = cart.currency || CFG.currency;
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cd-items');
    var footEl = drawer.querySelector('.cd-foot');
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="cd-empty">Your cart is empty.<br>Open Focus or Restore to get started.</div>';
      footEl.style.display = 'none';
    } else {
      footEl.style.display = 'block';
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var name = NAME_MAP[it.handle] || it.product_title;
        var plan = it.selling_plan_allocation ? '<span class="ci-s">' + it.selling_plan_allocation.selling_plan.name + '</span>' : '';
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '<div></div>';
        return '<div class="cd-item">' + img +
          '<div><div class="ci-t">' + name + '</div>' + plan +
          '<button class="ci-remove" data-line="' + (i + 1) + '">Remove</button></div>' +
          '<div class="ci-p">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    // free shipping progress — only meaningful in the base (US) currency
    var prog = drawer.querySelector('.cd-progress');
    if (prog && CFG.freeShipThreshold && cart.currency === CFG.currency) {
      prog.style.display = '';
      var thr = CFG.freeShipThreshold;
      var remain = thr - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / thr) * 100));
      prog.querySelector('.track i').style.width = pct + '%';
      prog.querySelector('.cd-progress-text').textContent = remain > 0
        ? "You're " + money(remain) + ' from free US shipping'
        : 'You’ve unlocked free US shipping ✓';
    } else if (prog) {
      prog.style.display = 'none';
    }
    // subtotal
    var sub = drawer.querySelector('.cd-sub-val');
    if (sub) sub.textContent = money(cart.total_price);
  }
  function refreshCart(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); })
      .catch(function () {});
  }
  function openCart() { if (drawer) drawer.classList.add('open'); }
  function closeCart() { if (drawer) drawer.classList.remove('open'); }

  function addToCart(variantId, quantity, sellingPlanId, productTitle) {
    var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (sellingPlanId) body.items[0].selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        toast((productTitle || 'Item') + ' added to cart ✓');
        refreshCart(true);
        return res;
      });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.classList.contains('cd-scrim') || e.target.closest('.cd-close')) { closeCart(); return; }
      var rm = e.target.closest('.ci-remove');
      if (rm) {
        var line = rm.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
        }).then(function (r) { return r.json(); }).then(renderCart);
      }
    });
  }
  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
  });

  /* product forms: intercept add-to-cart for the drawer */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = fd.get('quantity') || 1;
      var plan = fd.get('selling_plan') || null;
      var title = form.getAttribute('data-product-title') || 'Item';
      addToCart(id, qty, plan, title);
    });
  });

  /* one-click add buttons (cart upsell, cross-sell) */
  document.querySelectorAll('[data-add-variant]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(btn.getAttribute('data-add-variant'), 1, btn.getAttribute('data-add-plan') || null, btn.getAttribute('data-add-title') || 'Item');
    });
  });

  // sync count on load
  refreshCart(false);

  /* ---------- UGC lightbox (local mp4) ---------- */
  var lb = document.getElementById('lb');
  if (lb) {
    var vid = lb.querySelector('video');
    function openLB(src) {
      if (!src) return;
      vid.src = src; lb.classList.add('open'); document.body.style.overflow = 'hidden';
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    }
    function closeLB() { vid.pause(); vid.removeAttribute('src'); vid.load(); lb.classList.remove('open'); document.body.style.overflow = ''; }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.lb-close')) closeLB(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLB(); });
    document.querySelectorAll('.vcard[data-video]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openLB(a.getAttribute('data-video')); });
    });
  }

  /* ---------- newsletter (footer) graceful handler if AJAX form ---------- */
  window.Messless = { addToCart: addToCart, openCart: function () { refreshCart(true); }, toast: toast };
})();
